export default __webpack_public_path__ + "static/media/node-brands.9ab33389.svg";